import React from 'react';
import InlineEdit from '../../shared/components/edit-inline/EditInline';
// import CKEditor from 'react-ckeditor-component';
import Editor from 'react-simple-wysiwyg';
import { withSnackbar } from 'notistack';
import CompetencyService from '../services/competency/competency';
import ActiveRequestsService from '../services/active-requests/active-requests';

import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import ManageCompetency from './ManageCompetency';

var placeholder = document.createElement('li');
placeholder.className = 'placeholder';

class ManageDomains extends React.Component {
  activeRequests = new ActiveRequestsService();
  competencyService = new CompetencyService();
  constructor(props) {
    super(props);
    this.state = {
      loadingError: false,
      editable: false,
      showModal: false,
      newDomains: '',
      showModalCompetency: false,
      showModalMapping: false,
      newCompetencies: [{ competency: '', mapping: '' }],
      parentID: '',
      parentTitle: '',
      sorting: []
    };

    this.archiveDomain = this.archiveDomain.bind(this);
    this.OpenModalCompetency = this.OpenModalCompetency.bind(this);
    this.closeModalCompetency = this.closeModalCompetency.bind(this);

    this.OpenModalMapping = this.OpenModalMapping.bind(this);
    this.CloseModalMapping = this.CloseModalMapping.bind(this);

    this.handleRemoveCompetencies = this.handleRemoveCompetencies.bind(this);
    this.setCompetencies = this.setCompetencies.bind(this);

    this.OpenModalPosition = this.OpenModalPosition.bind(this);
    this.closeModalPosition = this.closeModalPosition.bind(this);
  }

  OpenModalMapping(e, domain) {
    this.setState({ showModalMapping: true });
    //this.setState({ domain: domain });
  }

  CloseModalMapping() {
    this.setState({ showModalMapping: false });
  }

  handleOpenModal() {
    this.setState({ showModal: true });
  }

  handleCloseModal() {
    this.setState({ showModal: false });
  }

  OpenModalPosition(e) {
    this.setState({ showModalPosition: true });
  }

  closeModalPosition() {
    this.setState({ showModalPosition: false });
  }

  OpenModalCompetency(e) {
    this.setState({ parentID: e.target.dataset.domainid });
    this.setState({ parentTitle: e.target.dataset.domaintitle });
    this.setState({ showModalCompetency: true });
  }

  closeModalCompetency() {
    this.setState({ showModalCompetency: false });
  }

  handleAddMoreCompetencies(e) {
    this.setState({
      newCompetencies: [
        ...this.state.newCompetencies,
        { competency: '', mapping: '' }
      ]
    });
    e.preventDefault();
  }

  handleRemoveCompetencies(e, index) {
    this.state.newCompetencies.splice(index, 1);
    this.setState({ newCompetencies: this.state.newCompetencies });
    e.preventDefault();
  }

  setCompetencies(e, index, type) {
    let newData = this.state.newCompetencies;
    if (type === 'competency') {
      newData[index].competency = e.target.value;
    } else {
      newData[index].mapping = e.target.value; //e.target.value;
    }
    this.setState({ newCompetencies: newData });
  }

  async saveCompetencies(e) {
    const { framework, frameworkData } = this.props;
    const { newCompetencies, parentID } = this.state;

    let versionID = frameworkData[0].version_id;
    let newData = newCompetencies;
    let type = 'competency';
    let addtional = '';
    e.preventDefault();

    try {
      this.activeRequests.startRequest();
      await this.competencyService.createBulkData(
        parentID,
        versionID,
        newData,
        type,
        addtional
      );
      await this.props.loadData(framework);
    } catch (e) {
      this.props.enqueueSnackbar('Unable to perform the request', {
        variant: 'error'
      });
    } finally {
      this.activeRequests.finishRequest();
      this.props.enqueueSnackbar('Competencies added successfully', {
        variant: 'success'
      });
    }
    this.setState({ newCompetencies: [{ competency: '', mapping: '' }] });
    this.closeModalCompetency();
  }

  async editDomain(domain, title) {
    const { framework } = this.props;
    try {
      this.activeRequests.startRequest();
      await this.competencyService.patchDomain(domain, 'title', title);
      await this.props.loadData(framework);
      await this.props.enqueueSnackbar('Domain updated', {
        variant: 'success'
      });
    } catch (e) {
      this.props.enqueueSnackbar('Unable to perform the request', {
        variant: 'error'
      });
    } finally {
      this.activeRequests.finishRequest();
      // this.props.enqueueSnackbar('Domain updated', {
      //   variant: 'success'
      // });
    }
  }

  async archiveDomain(domain, isArchived) {
    const { framework } = this.props;
    try {
      //this.activeRequests.startRequest();
      await this.competencyService.toggleArchivingVersionedNode(
        framework,
        domain
      );
      this.props.loadData(framework);
    } catch (e) {
      this.props.enqueueSnackbar('Unable to perform the request', {
        variant: 'error'
      });
    } finally {
      //this.activeRequests.finishRequest();
      this.props.enqueueSnackbar('Domain updated', {
        variant: 'success'
      });
    }
  }

  dragStart(e) {
    this.dragged = e.currentTarget;
    e.dataTransfer.effectAllowed = 'move';
    e.dataTransfer.setData('text/html', this.dragged);
  }
  dragEnd(e) {
    this.dragged.style.display = 'block';
    this.dragged.parentNode.removeChild(placeholder);
    //update state and call api for PATCH request
    var data = this.props.frameworkData[0].domains;
    var from = Number(this.dragged.dataset.position);
    var to = Number(this.over.dataset.position);
    if (from < to) to--;
    data.splice(to, 0, data.splice(from, 1)[0]);
    this.setState({ sorting: data });
  }
  dragOver(e) {
    e.preventDefault();
    this.dragged.style.display = 'none';
    if (e.target.className === 'placeholder') return;
    this.over = e.target;
    e.target.parentNode.insertBefore(placeholder, e.target);
  }

  saveSorting = async data => {
    const { framework } = this.props;
    const { sorting } = this.state;
    let items = sorting.map(d => d.nid);
    try {
      this.activeRequests.startRequest();
      await this.competencyService.saveSorting(items);
      await this.props.loadData(framework);
      this.props.enqueueSnackbar('Items updated', {
        variant: 'success'
      });
    } catch {
      this.props.enqueueSnackbar('Unable to perform the request', {
        variant: 'error'
      });
    } finally {
      this.setState({ sorting: undefined });
      this.closeModalPosition();
      //window.location.reload()
      this.activeRequests.finishRequest();
    }
  };

  render() {
    const {
      framework,
      frameworkData,
      frameworkDef,
      loadData,
      editableFrm
    } = this.props;
    const domains = frameworkData.map((item, key) =>
      item.domains.map((domain, key) => (
        <li
          key={'li_' + key}
          id={domain.nid}
          className={domain.archived === '1' ? 'strikeout' : ''}
          style={{ listStyleType: 'none' }}
        >
          <div key={'div1_' + domain.nid} className="row domain_title">
            <hr key={'hr_' + key} />
            <div key={'div2_' + domain.nid} className="column medium-12">
              <h2 key={'h4_' + domain.nid}>
                <InlineEdit
                  style={{ display: 'inline' }}
                  text={domain.title}
                  change={newValue => this.editDomain(domain.nid, newValue)}
                  editable={
                    domain.archived === '1' || editableFrm === false
                      ? false
                      : true
                  }
                  key={'inline_edit_1_' + domain.nid + key}
                />
                {editableFrm !== false ? (
                  <>
                    <span
                      key={'span_1_' + domain.nid}
                      className="edit-indicator"
                    >
                      <button
                        key={domain.nid}
                        className="ch_link "
                        onClick={() =>
                          this.archiveDomain(domain.nid, domain.archived)
                        }
                      >
                        {domain.archived === '1' ? (
                          <span className="ch_link fas fa-toggle-on icon-left-spacer">
                            <span>Archived</span>
                          </span>
                        ) : (
                          <span className="fas fa-toggle-off icon-left-spacer">
                            {' '}
                            <span> Archive</span>
                          </span>
                        )}
                      </button>
                    </span>
                    <span
                      key={'span_2_' + domain.nid}
                      className="edit-indicator"
                    >
                      <button
                        className="ch_link addButton"
                        onClick={this.OpenModalPosition}
                      >
                        {' '}
                        <i className="icon icon-common icon-sort icon-left-spacer" />{' '}
                        Change order{' '}
                      </button>
                    </span>
                    {domain.archived !== '1' ? (
                      <span
                        key={'span_3_' + domain.nid}
                        className="edit-indicator"
                      >
                        <button
                          className="ch_link addButton icon icon-common icon-plus-circle icon-left-spacer"
                          href="#"
                          data-domainid={domain.nid}
                          data-domaintitle={domain.title}
                          onClick={e => this.OpenModalCompetency(e)}
                        >
                          Add competencies
                        </button>
                      </span>
                    ) : (
                      ''
                    )}
                  </>
                ) : (
                  ''
                )}
              </h2>
            </div>
          </div>
          <div key={'p_' + domain.nid}>
            <ManageCompetency
              framework={framework}
              frameworkData={frameworkData}
              frameworkDef={frameworkDef}
              loadData={loadData}
              domain={domain}
              editableFrm={editableFrm}
              key={domain.nid}
            />
          </div>
        </li>
      ))
    );

    return (
      <div>
        {domains[0].length > 0 ? (
          <>
            <ul key={'ul__domains' + domains.count}>{domains}</ul>{' '}
          </>
        ) : (
          <>
            <p className="callout">
              No data found. You may start by adding domains.
            </p>{' '}
          </>
        )}

        {/* Modal for mapping */}

        {/* <Modal
          open={this.state.showModalCompetency}
          onClose={this.closeModalCompetency}
          center
          classNames={{
            overlay: 'customOverlay',
            modal: 'customModal'
          }}
        >
         <form onSubmit={e => this.saveCompetencies(e)}>
            {this.state.newCompetencies.map((item, index) => (
              <div key={'competency_' + index} className="row callout">
                <div className="column medium-9">

                  Add/edit this competency maps to:
  
                   <CKEditor
                    key={'mapsto_' + index}
                    content={item.mapping}
                    events={{
                      change: (e) => this.setCompetencies(e, index, 'mapping')
                    }}
                    activeClass="p10"
                    config={{
                      toolbarGroups :[
                        { name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
                        { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
                        { name: 'links', groups: [ 'links' ] },
                    ]
                  }}
                  />
                </div>

              </div>
            ))}

            <input type="submit" className="button" value="Save" />
          </form> 
        </Modal> */}

        {/* Modal for competencies */}

        <Modal
          open={this.state.showModalCompetency}
          onClose={this.closeModalCompetency}
          center
          classNames={{
            overlay: 'customOverlay',
            modal: 'customModal'
          }}
        >
          <h2>{this.state.parentTitle}</h2>
          <h3>Add competencies(s) </h3>

          <form className="vf-form" onSubmit={e => this.saveCompetencies(e)}>
            {this.state.newCompetencies.map((item, index) => (
              <div key={'competency_' + index} className="row callout">
                <div className="column medium-9">
                  Competency
                  <input
                    key={index}
                    type="text"
                    onChange={e => this.setCompetencies(e, index, 'competency')}
                    value={item.competency}
                    required
                    className="vf-form__input"
                  />
                  This competency maps to:
                  {/* <CKEditor
                    key={'mapsto_' + index}
                    className="vf-form__input"
                    content={item.mapping}
                    events={{
                      change: e => this.setCompetencies(e, index, 'mapping')
                    }}
                    activeClass="p10"
                    config={{
                      toolbarGroups: [
                        {
                          name: 'document',
                          groups: ['mode', 'document', 'doctools']
                        },
                        {
                          name: 'paragraph',
                          groups: [
                            'list',
                            'indent',
                            'blocks',
                            'align',
                            'bidi',
                            'paragraph'
                          ]
                        },
                        { name: 'links', groups: ['links'] }
                      ]
                    }}
                  /> */}
                  <Editor
                    key={'mapsto_' + index}
                    className="vf-form__input"
                    containerProps={{
                      style: { resize: 'vertical', height: '150px' }
                    }}
                    value={item.mapping}
                    onChange={e => this.setCompetencies(e, index, 'mapping')}
                  />
                </div>
                <div className="column medium-3" style={{ paddingTop: '1%' }}>
                  {index > 0 ? (
                    <button
                      className="vf-button vf-button--sm"
                      onClick={e => this.handleRemoveCompetencies(e, index)}
                    >
                      <i className="icon icon-common icon-close" />{' '}
                    </button>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            ))}

            <div className="row">
              <div className="column medium-10">
                <button
                  className="vf-button vf-button--sm vf-button--secondary"
                  onClick={e => this.handleAddMoreCompetencies(e)}
                >
                  <i className="icon icon-common icon-plus-circle" /> Add more
                </button>
              </div>
            </div>
            <input
              type="submit"
              className="vf-button vf-button--sm vf-button--primary"
              value="Save"
            />
          </form>
        </Modal>

        {/* Modal for sorting domain positions */}

        <Modal
          open={this.state.showModalPosition}
          onClose={this.closeModalPosition}
          center
          classNames={{
            overlay: 'customOverlay',
            modal: 'customModal'
          }}
        >
          <h3>Change order</h3>
          <p>Please drag and drop items to change order</p>

          <ul onDragOver={this.dragOver.bind(this)}>
            {frameworkData.map(item =>
              item.domains.map((domain, i) => {
                return (
                  <li
                    style={{
                      listStyleType: 'none',
                      padding: '15px',
                      border: '1px solid #ccc'
                    }}
                    data-position={i}
                    key={domain.id || `${item.position}-${i}`}
                    draggable="true"
                    onDragEnd={this.dragEnd.bind(this)}
                    onDragStart={this.dragStart.bind(this)}
                  >
                    <i className="icon icon-common icon-move" /> {domain.title}
                  </li>
                );
              })
            )}
          </ul>
          <button
            className="vf-button vf-button--sm vf-button--primary"
            onClick={this.saveSorting}
          >
            Save
          </button>
        </Modal>
      </div>
    );
  }
}

export default withSnackbar(ManageDomains);
